export default {"src":"/_next/static/media/linkedin-share.57b35383.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};